export default "__VITE_ASSET__18354aed__"